/* AI Visual Search: camera/upload -> Gemini -> store products (theme ke normal product cards). Settings: Theme editor > Header > AI Visual Search */
(function () {
  var cleanup = null;
  var BUILTIN_MODELS = ['gemini-3.8-flash', 'gemini-3.5-flash-lite', 'gemini-3.6-flash'];
  var NL = String.fromCharCode(10);

  function init() {
    if (cleanup) { try { cleanup(); } catch (e) {} cleanup = null; }
    var cfgEl = document.querySelector('[data-aivs-config]');
    var modal = document.querySelector('[data-aivs-modal]');
    var trigger = document.querySelector('.aivs-trigger[data-aivs-open]');
    if (!cfgEl || !modal || !trigger) return;
    var CFG = JSON.parse(cfgEl.textContent), T = CFG.t;

    document.body.appendChild(modal);
    var icons = document.querySelector('.header__icons');
    if (icons) icons.insertBefore(trigger, icons.querySelector('#cart-icon-bubble') || null);
    else trigger.classList.add('aivs-floating');

    var $ = function (s) { return modal.querySelector(s); };
    var pick = $('[data-aivs-pick]'), live = $('[data-aivs-live]'), video = $('[data-aivs-video]');
    var loading = $('[data-aivs-loading]'), statusEl = $('[data-aivs-status]'), preview = $('[data-aivs-preview]');
    var errEl = $('[data-aivs-error]'), resEl = $('[data-aivs-results]');
    var fileIn = $('[data-aivs-file]'), fileCam = $('[data-aivs-file-cam]');
    var stream = null, lastImage = '', lastErr = '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function show(el, v) { el.hidden = !v; }
    function view(n) {
      show(pick, n === 'pick'); show(live, n === 'live'); show(loading, n === 'loading'); show(resEl, n === 'results');
      if (n !== 'error') show(errEl, false);
    }
    function fail(msg) {
      errEl.innerHTML = esc(msg) + ` <button type='button' class='aivs-btn' style='margin-left:8px;padding:6px 12px' data-aivs-again>${esc(T.retry)}</button>`;
      view('error'); show(errEl, true); show(pick, true);
    }
    function openM() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; reset(); }
    function closeM() { stopCam(); modal.hidden = true; document.documentElement.style.overflow = ''; }
    function reset() { stopCam(); show(errEl, false); resEl.innerHTML = ''; view('pick'); }
    function stopCam() { if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; } video.srcObject = null; }

    function onClick(e) {
      var t = e.target;
      if (t.closest('[data-aivs-open]')) { e.preventDefault(); openM(); }
      else if (modal.contains(t)) {
        if (t.closest('[data-aivs-close]')) closeM();
        else if (t.closest('[data-aivs-upload]')) fileIn.click();
        else if (t.closest('[data-aivs-camera]')) startCam();
        else if (t.closest('[data-aivs-snap]')) snap();
        else if (t.closest('[data-aivs-cancel-cam]') || t.closest('[data-aivs-again]')) reset();
      }
    }
    function onKey(e) { if (e.key === 'Escape' && !modal.hidden) closeM(); }
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    cleanup = function () {
      document.removeEventListener('click', onClick); document.removeEventListener('keydown', onKey);
      stopCam(); document.documentElement.style.overflow = ''; modal.remove(); trigger.remove();
    };

    function startCam() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { fileCam.click(); return; }
      navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false })
        .then(function (s) { stream = s; video.srcObject = s; view('live'); if (video.play) { var pp = video.play(); if (pp && pp.catch) pp.catch(function () {}); } })
        .catch(function () { fileCam.click(); });
    }
    function snap() {
      if (!video.videoWidth || !video.videoHeight) return;
      var c = document.createElement('canvas'); c.width = video.videoWidth; c.height = video.videoHeight;
      c.getContext('2d').drawImage(video, 0, 0); stopCam(); handleCanvas(c);
    }
    [fileIn, fileCam].forEach(function (inp) {
      inp.addEventListener('change', function () {
        var f = inp.files && inp.files[0]; inp.value = '';
        if (!f) return;
        var url = URL.createObjectURL(f), img = new Image();
        img.onload = function () {
          var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
          c.getContext('2d').drawImage(img, 0, 0); URL.revokeObjectURL(url); handleCanvas(c);
        };
        img.onerror = function () { fail('Image open nahi ho saki.'); };
        img.src = url;
      });
    });
    function handleCanvas(src) {
      var k = Math.min(1, 2000 / Math.max(src.width, src.height));
      var c = document.createElement('canvas'); c.width = Math.round(src.width * k); c.height = Math.round(src.height * k);
      c.getContext('2d').drawImage(src, 0, 0, c.width, c.height);
      var data = c.toDataURL('image/jpeg', 0.9);
      lastImage = data; preview.src = data; run(data.split(',')[1]);
    }

    /* ---------- Gemini ---------- */
    function buildPrompt() {
      var L = [];
      L.push('You are the visual search assistant of "' + CFG.shop + '", a Pakistani store selling school books, notes, novels, stationery, school uniforms, bags and shoes.');
      L.push('Look at the image carefully and reply ONLY with JSON in this shape:');
      L.push('{"type":"product"|"list"|"unknown","summary":"one short sentence saying what you read/see","items":[{"name":"best catalog-style title","quantity":1,"terms":["most specific search phrase","next phrase","broadest phrase"]}]}');
      L.push('Rules:');
      L.push('- If the image shows physical product(s): type "product", one item per distinct product.');
      L.push('- BOOKS are the most important case. Read ALL visible text on the cover, spine or back slowly and carefully, letter by letter, in any script (Urdu, Arabic script, English). Urdu is written right to left. Never guess or invent letters or words. Identify: exact title, author, publisher, class or level, subject, series or edition, and ISBN or barcode digits if visible.');
      L.push('- For every Urdu or Arabic-script title or name, give the Roman Urdu spelling a Pakistani store would type (include the most common spelling variant of difficult words) AND the English meaning. The store catalog may be in English, Roman Urdu or Urdu script.');
      L.push('- "name" = the best catalog-style title in Roman Urdu or English (add the author after a dash if known).');
      L.push('- "terms" = search phrases ordered from most specific to broadest, maximum 6, each 1 to 5 words: (1) ISBN digits if visible, (2) exact title in Roman Urdu, (3) title in English, (4) title in the original Urdu script, (5) author plus subject or class, (6) subject plus class or category. Skip any that do not apply.');
      L.push('- If part of the text is unreadable, use only what is clearly readable and add type, subject, class or colour as broader terms. Never return unrelated products.');
      if (CFG.listMode) L.push('- If the image is a written or printed list or slip (school book list, course or book requisition slip, stationery list, uniform list, handwritten list): type "list". Read EVERY line and EVERY item, one item per line, keep quantity if written. terms should include class, subject, publisher or author when present. English, Urdu and Roman Urdu handwriting are all possible.');
      else L.push('- Treat any image as type "product".');
      L.push('- Maximum 25 items. If nothing recognisable, type "unknown" with empty items.');
      if (CFG.extra) L.push('- Extra store instructions: ' + CFG.extra);
      return L.join(NL) + NL;
    }
    function parseText(t) {
      t = (t || '').replace(/^```(?:json)?/i, '').replace(/```$/, '').trim();
      try { return JSON.parse(t); } catch (e) {}
      var a = t.indexOf('{'), b = t.lastIndexOf('}');
      if (a > -1 && b > a) return JSON.parse(t.slice(a, b + 1));
      throw new Error('bad json');
    }
    function fromGemini(d) {
      var cand = d && d.candidates && d.candidates[0];
      var p = cand && cand.content && cand.content.parts;
      if (!p) throw new Error('empty (' + ((cand && cand.finishReason) || (d && d.promptFeedback && d.promptFeedback.blockReason) || 'no candidates') + ')');
      return parseText(p.filter(function (x) { return !x.thought; }).map(function (x) { return x.text || ''; }).join(''));
    }
    function splitKeys(s) {
      return String(s || '').split(String.fromCharCode(10)).join(' ').split(String.fromCharCode(13)).join(' ').split(',').join(' ').split(';').join(' ').split(' ').filter(Boolean);
    }
    function cooldowns() { try { return JSON.parse(sessionStorage.getItem('aivsCool') || '{}'); } catch (e) { return {}; } }
    function setCool(key, ms) { var c = cooldowns(); c[key] = Date.now() + ms; try { sessionStorage.setItem('aivsCool', JSON.stringify(c)); } catch (e) {} }

    async function detect(b64) {
      var prompt = buildPrompt();
      if (CFG.proxy) {
        var r = await fetch(CFG.proxy, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ image: b64, mime: 'image/jpeg', prompt: prompt }) });
        if (!r.ok) throw new Error('proxy ' + r.status);
        var pd = await r.json();
        return pd.candidates ? fromGemini(pd) : (pd.result || pd);
      }
      var keys = splitKeys(CFG.keys);
      if (!keys.length) throw new Error('NOKEY');

      var cfgModels = [CFG.model, CFG.fallbackModel].filter(Boolean);
      var modern = cfgModels.filter(function (m) { return !/^gemini-2/.test(m); });
      var legacy = cfgModels.filter(function (m) { return /^gemini-2/.test(m); });
      var models = modern.concat(BUILTIN_MODELS, legacy).filter(function (m, i, a) { return a.indexOf(m) === i; });

      var cool = cooldowns(), now = Date.now();
      var order = keys.filter(function (k) { return !(cool[k] && cool[k] > now); })
        .concat(keys.filter(function (k) { return cool[k] && cool[k] > now; }));

      function mkBody(model, think) {
        var gc = { responseMimeType: 'application/json' };
        if (/^gemini-3/.test(model)) { if (think) gc.thinkingConfig = { thinkingLevel: 'low' }; }
        else gc.temperature = 0.1;
        return JSON.stringify({
          contents: [{ parts: [{ text: prompt }, { inline_data: { mime_type: 'image/jpeg', data: b64 } }] }],
          generationConfig: gc
        });
      }

      for (var m = 0; m < models.length; m++) {
        var think = true, skipModel = false;
        for (var i = 0; i < order.length && !skipModel; i++) {
          var key = order[i];
          for (var attempt = 0; attempt < 2; attempt++) {
            var res;
            try {
              res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/' + encodeURIComponent(models[m]) + ':generateContent', {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'x-goog-api-key': key }, body: mkBody(models[m], think)
              });
            } catch (e) { lastErr = 'network/CORS: ' + e.message; break; }
            if (res.ok) {
              try { return fromGemini(await res.json()); }
              catch (e2) { lastErr = models[m] + ' parse: ' + String(e2.message).slice(0, 100); skipModel = true; break; }
            }
            var msg = ''; try { msg = (await res.json()).error.message || ''; } catch (e3) {}
            lastErr = res.status + ' (' + models[m] + ')' + (msg ? ': ' + msg.slice(0, 140) : '');
            if (window.console) console.warn('[AI search] ' + lastErr);
            var keyBad = res.status === 401 || (res.status === 400 && /api key|API_KEY/i.test(msg));
            if (keyBad) { setCool(key, 600000); break; }
            if (res.status === 400 && think) { think = false; continue; }
            if (res.status === 429) setCool(key, 60000);
            else if (res.status === 403) setCool(key, 600000);
            else skipModel = true;
            break;
          }
        }
        if (/^401/.test(lastErr) || /API key/i.test(lastErr)) break;
      }
      throw new Error('ALLFAIL');
    }

    /* ---------- Store search: theme ke card-product snippet ke cards (Section Rendering API) ---------- */
    async function suggest(q, limit) {
      var url = root + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + Math.min(10, limit) + '&resources[options][unavailable_products]=last&section_id=ai-search-results';
      try {
        var r = await fetch(url); if (!r.ok) return [];
        var doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        return Array.prototype.map.call(doc.querySelectorAll('[data-aivs-card]'), function (el) {
          return { id: el.getAttribute('data-id'), handle: el.getAttribute('data-handle'), available: el.getAttribute('data-available') !== 'false', html: el.innerHTML };
        });
      } catch (e) { return []; }
    }
    async function findFor(item, isList) {
      var out = [], ids = {};
      var terms = (item.terms && item.terms.length ? item.terms : [item.name]).slice(0, 6);
      if (item.name && terms.indexOf(item.name) < 0) terms.unshift(item.name);
      function add(found) { found.forEach(function (p) { if (!ids[p.id] && out.length < CFG.max) { ids[p.id] = 1; out.push(p); } }); }
      for (var i = 0; i < terms.length && out.length < CFG.max; i++) {
        add(await suggest(terms[i], CFG.max));
        if (isList && out.length >= Math.min(2, CFG.max)) break;
      }
      if (!out.length) {
        var tried = {};
        for (var t = 0; t < terms.length && !out.length; t++) {
          var w = String(terms[t]).split(' ').filter(Boolean);
          for (var n = w.length - 1; n >= 1 && !out.length; n--) {
            var q = w.slice(0, n).join(' ');
            if (tried[q] || q.length < 3) continue;
            tried[q] = 1; add(await suggest(q, CFG.max));
          }
        }
      }
      return out;
    }

    /* ---------- Bina-AI fallback: OCR (Tesseract.js) -> text lines -> store search ---------- */
    var TESS_URL = 'https://cdn.jsdelivr.net/npm/tesseract.js@5.1.1/dist/tesseract.min.js';
    function loadTess() {
      return new Promise(function (resolve, reject) {
        if (window.Tesseract) return resolve(window.Tesseract);
        var sc = document.createElement('script'); sc.src = TESS_URL; sc.async = true;
        sc.onload = function () { window.Tesseract ? resolve(window.Tesseract) : reject(new Error('ocr missing')); };
        sc.onerror = function () { reject(new Error('ocr load failed')); };
        document.head.appendChild(sc);
      });
    }
    function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
    function cleanLine(l) {
      var out = '', ok = ' .-&/()';
      for (var i = 0; i < l.length; i++) {
        var ch = l.charAt(i), lo = ch.toLowerCase();
        out += ((lo >= 'a' && lo <= 'z') || (ch >= '0' && ch <= '9') || ok.indexOf(ch) > -1) ? ch : ' ';
      }
      return out.split(' ').filter(Boolean).join(' ');
    }
    function letters(l) { var n = 0; for (var i = 0; i < l.length; i++) { var c = l.charAt(i).toLowerCase(); if (c >= 'a' && c <= 'z') n++; } return n; }
    function termsFor(line) {
      var w = line.split(' ').filter(Boolean);
      var long = w.filter(function (x) { return letters(x) >= 4; }).sort(function (a, b) { return b.length - a.length; });
      return uniq([w.slice(0, 6).join(' '), w.slice(0, 3).join(' '), long.slice(0, 2).join(' ')]).filter(function (x) { return x.length >= 3; }).slice(0, 3);
    }
    async function ocrResult(dataUrl) {
      var Tess = await loadTess();
      var r = await Tess.recognize(dataUrl, 'eng', { logger: function (m) {
        if (m && m.status === 'recognizing text' && statusEl) statusEl.textContent = 'Text scan: ' + Math.round((m.progress || 0) * 100) + '%';
      } });
      var raw = (r && r.data && r.data.text) || '';
      var lines = uniq(raw.split(NL).map(cleanLine).filter(function (l) { return l.length >= 4 && letters(l) >= 3; })).slice(0, 25);
      if (!lines.length) return null;
      if (lines.length <= 2) {
        var one = lines.join(' ').split(' ').slice(0, 10).join(' ');
        return { type: 'product', summary: 'Photo ke text se match (bina AI): ' + one, items: [{ name: one, quantity: 1, terms: termsFor(one) }] };
      }
      return { type: 'list', summary: 'Photo ka text padh kar match dhoonde (bina AI)', items: lines.map(function (l) { return { name: l, quantity: 1, terms: termsFor(l) }; }) };
    }

    async function run(b64) {
      view('loading'); statusEl.textContent = T.analyzing; lastErr = '';
      var result = null, aiMsg = '';
      try { result = await detect(b64); }
      catch (e) {
        aiMsg = e.message === 'NOKEY' ? T.errNoKey : T.errAll + (lastErr ? ' [' + lastErr + ']' : (e.message ? ' [' + e.message.slice(0, 140) + ']' : ''));
      }
      var items = (result && result.items || []).slice(0, 25);
      if (!items.length) {
        var aiSummary = result && result.summary;
        try { statusEl.textContent = 'Text scan kar rahe hain...'; result = await ocrResult(lastImage); } catch (oe) { result = null; if (window.console) console.warn('[AI search] OCR: ' + oe.message); }
        items = (result && result.items || []).slice(0, 25);
        if (!items.length) { fail(aiMsg ? aiMsg + ' Text scan me bhi kuch nahi mila - text wali saaf photo try karein.' : (aiSummary || T.noMatch)); return; }
      }
      statusEl.textContent = T.searching;
      var isList = result.type === 'list';
      var matches = await Promise.all(items.map(function (it) { return findFor(it, isList); }));
      render(result, items, matches, isList);
    }

    /* ---------- Results: theme ka normal product card + (optional) Add to cart ---------- */
    function card(p) {
      return `<div class='aivs-cell'>${p.html}${CFG.addBtn && p.available ? `<button type='button' class='button button--full-width button--secondary' data-add='${esc(p.handle)}'>${esc(T.add)}</button>` : ''}</div>`;
    }
    function render(result, items, matches, isList) {
      var h = `<div class='aivs-sum'><img src='${esc(lastImage)}' alt=''><p>${esc(result.summary || '')}</p><button type='button' class='aivs-btn' data-aivs-again>${esc(T.retry)}</button></div>`;
      items.forEach(function (it, i) {
        var q = it.quantity && it.quantity > 1 ? ' <small>x ' + it.quantity + '</small>' : '';
        var title = isList ? esc(it.name) + q : (it.name ? esc(it.name) : esc(T.similar));
        h += `<div class='aivs-sec'><h3>${title}</h3>`;
        if (matches[i].length) h += `<div class='aivs-grid'>${matches[i].map(card).join('')}</div>`;
        else h += `<p class='aivs-none'>${esc(T.noMatch)} <a href='${root}search?q=${encodeURIComponent(it.name)}'>${esc(it.name)} &rarr;</a></p>`;
        h += '</div>';
      });
      if (isList) h += `<div class='aivs-foot'><button type='button' class='aivs-btn aivs-btn--primary' data-add-all>${esc(T.addAll)}</button><span class='aivs-msg' data-aivs-msg></span></div>`;
      resEl.innerHTML = h; resEl._data = { items: items, matches: matches }; view('results');
    }

    /* ---------- Cart ---------- */
    async function productJs(handle) { var r = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js'); if (!r.ok) throw new Error('p'); return r.json(); }
    async function addToCart(lines) {
      var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }) });
      if (!r.ok) throw new Error('cart');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return r.json();
    }
    var needsOptions = function (p) { return p.variants.length > 1; };

    resEl.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-add]');
      if (btn) {
        btn.disabled = true;
        try {
          var p = await productJs(btn.getAttribute('data-add'));
          if (needsOptions(p)) { window.location.href = root + 'products/' + p.handle; return; }
          var v = p.variants.find(function (x) { return x.available; });
          if (!v) { btn.textContent = '-'; return; }
          await addToCart([{ id: v.id, quantity: 1 }]);
          btn.outerHTML = `<a class='button button--full-width button--secondary' href='${root}cart'>${esc(T.added)} &#10003; ${esc(T.viewCart)}</a>`;
        } catch (er) { btn.disabled = false; }
        return;
      }
      var all = e.target.closest('[data-add-all]');
      if (all) {
        var msg = resEl.querySelector('[data-aivs-msg]'), d = resEl._data, lines = [], skipped = 0;
        all.disabled = true;
        for (var i = 0; i < d.items.length; i++) {
          var top = d.matches[i][0]; if (!top) continue;
          try {
            var pr = await productJs(top.handle);
            if (needsOptions(pr)) { skipped++; continue; }
            var va = pr.variants.find(function (x) { return x.available; });
            if (va) lines.push({ id: va.id, quantity: Math.max(1, parseInt(d.items[i].quantity, 10) || 1) });
          } catch (er) {}
        }
        try {
          if (lines.length) await addToCart(lines);
          msg.innerHTML = esc(T.added) + ': ' + lines.length + (skipped ? ' | ' + skipped + ' items ko size/option chahiye (khud select karein)' : '') + ` - <a href='${root}cart'>${esc(T.viewCart)}</a>`;
        } catch (er) { msg.textContent = 'Cart me add nahi ho saka.'; }
        all.disabled = false;
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-aivs-config]')) init();
  });
})();
